const initialState = {
  easyCardList: [],
  initState: false,
  loading: true,
};

export const LOADING = "LOADING";
export const loadingAction = (data) => ({
  type: LOADING,
  payload: data,
});

export const LOAD_PAY_LIST = "LOAD_PAY_LIST";
export const loadPayListAction = (data) => ({
  type: LOAD_PAY_LIST,
  payload: data,
});

export const RESET_PAY = "RESET_PAY";
export const resetPay = () => ({
  type: RESET_PAY,
  payload: initialState,
});

export const LOAD_LIST_SUCCESS = "LOAD_LIST_SUCCESS";
export const loadListSuccessAction = (data) => ({
  type: LOAD_LIST_SUCCESS,
  payload: data,
});

export const LOAD_CHECK_TERMS = "LOAD_CHECK_TERMS";
export const loadCheckTermsAction = (data) => ({
  type: LOAD_CHECK_TERMS,
  payload: data,
});

export const LOAD_CHECK_TERMS_SUCCESS = "LOAD_CHECK_TERMS_SUCCESS";
export const loadCheckTermsSuccessAction = (data) => ({
  type: LOAD_CHECK_TERMS_SUCCESS,
  payload: data,
});

export default function PayReducer(state = initialState, action) {
  const { type, payload, error } = action;

  console.log("PayReducer = type", type, "payload", payload);

  switch (type) {
    case LOADING:
      return {
        ...state,
        loading: payload,
      };
    case LOAD_PAY_LIST:
      return {
        ...state,
        loading: false,
      };
    case LOAD_LIST_SUCCESS:
      return {
        ...state,
        easyCardList: payload,
        loading: false,
      };
    case LOAD_CHECK_TERMS:
      return {
        ...state,
        loading: false,
      };
    case LOAD_CHECK_TERMS_SUCCESS:
      return {
        ...state,
        checkTerms: payload,
        loading: false,
      };
    case RESET_PAY:
      return {
        ...state,
        easyCardList: [],
      };
    default:
      return state;
  }
}
